<template>
      <BreadCrumb PageTitle=" Ajouter une facture" />
    <AddFactureS/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddFactureS from "@/components/FactureS/AddFactureS.vue";
  
    export default defineComponent({
      name: "AddFactureSPage",
      components: {
        BreadCrumb ,
        AddFactureS,
      },
    });
  </script>